<template>
  <div class="conrainer">
        <BigScreenHead>
          <template v-slot:center >
              <div class="head-title">{{info.name}}</div>
          </template>
        </BigScreenHead>
        <main>
            <div class="top">
                <div class="chart-pie-box">
                    <div class="chartitle">总购买量（台）</div>
                    <div class="chart-pie"></div>
                </div>
                <div class="table-box">
                    <table>
                        <tr>
                            <td v-overflow>客户名称</td>
                            <td v-overflow>{{info.name}}</td>
                            <td v-overflow>客户地区</td>
                            <td v-overflow>{{info.areaName}}</td>
                        </tr>
                        <tr>
                            <td v-overflow>客户地址</td>
                            <td v-overflow>{{info.address}}</td>
                            <td v-overflow>法人代表</td>
                            <td v-overflow>{{info.legalPerson}}</td>
                        </tr>
                        <tr>
                            <td v-overflow>统一代码</td>
                            <td v-overflow>{{info.unicode}}</td>
                            <td v-overflow>企业性质</td>
                            <td v-overflow>{{info.nature}}</td>
                        </tr>
                        <tr>
                            <td v-overflow>从事行业</td>
                            <td v-overflow>{{info.trade}}</td>
                            <td v-overflow>所属厂商</td>
                            <td v-overflow :title="info.groupName">{{info.groupName}}</td>
                        </tr>
                        <tr>
                            <td v-overflow>联系人</td>
                            <td v-overflow>{{info.linker}}</td>
                            <td v-overflow>联系电话</td>
                            <td v-overflow>{{info.linkerTel}}</td>
                        </tr>
                    </table>
                </div>
                <div class="chart-line1"></div>
                <div class="chart-line2"></div>
            </div>
            <div class="bottom">
                <div class="map"></div>
                <div class="bottom-right">
                    <div class="info">
                        <div class="info-left">
                            <div class="item">
                                <div class="item-top">
                                    <img src="../assets/images/yuan.webp" alt="">
                                    <div class="count">{{mapInfo.overdueCount}}</div>
                                </div>
                                <div class="item-title">还款超期台次</div>
                            </div>
                            <div class="item">
                                <div class="item-top">
                                    <img src="../assets/images/yuan.webp" alt="">
                                    <div class="count">{{mapInfo.lockCount}}</div>
                                </div>
                                <div class="item-title">锁机台次</div>
                            </div>
                            <div class="item">
                                <div class="item-top">
                                    <img src="../assets/images/yuan.webp" alt="">
                                    <div class="count">{{mapInfo.repairCount}}</div>
                                </div>
                                <div class="item-title">报修台次</div>
                            </div>
                        </div>
                        <div class="info-title">
                            <p>销</p>
                            <p>售</p>
                            <p>紧</p>
                            <p>密</p>
                            <p>度</p>
                        </div>
                        <div class="info-ul">
                            <ul>
                                <li v-for="(item,i) in historyList" :key="i" >
                                    <div :style="{color:i==0?'#EDB941':i==1?'#6D9E7B':i==2?'#7194F3':''}">TOP{{i+1}}</div>
                                    <div>{{item.salesPerson}}</div>
                                    <div>{{item.salesPersonTel}}</div>
                                    <div><span v-if="item.count">（{{'合作'+item.count+'次'}}）</span> </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="tabletitle">合同列表（{{listTotal}}个）</div>
                    <div class="tablebox">
                        <table>
                            <tr>
                                <td style="width:5%"></td>
                                <td>合同号</td>
                                <td style="width:11%">产品型号</td>
                                <td>出厂编号</td>
                                <td style="width:10%">发货日期</td>
                                <td>发货地点</td>
                                <td style="width:8%">销售员</td>
                                <td style="width:9%">设备实况</td>
                            </tr>
                            <tr v-for="(item,i) in list" :key="item.id">
                                <td>{{i+1}}</td>
                                <td v-overflow>{{item.contractNo}}</td>
                                <td v-overflow>{{item.modelName}}</td>
                                <td v-overflow>{{item.factorNo}}</td>
                                <td v-overflow>{{item.sendDate | timeFomart}}</td>
                                <td v-overflow>{{item.sendAddress}}</td>
                                <td v-overflow>{{item.salesPerson}}</td>
                                <td>
                                    <button v-if="item.id && item.type==1" class="chakan-btn" @click="toDevice(item,1)">查 看</button>
                                    <button v-if="item.id && item.type==2" :disabled="!item.imei" :style="{background:!item.imei && '#ccc'}" class="chakan-btn" @click="toDevice(item,1)">左 笼</button>
                                    <button v-if="item.id && item.type==2" :disabled="!item.rightImei" :style="{marginLeft:'7%',background:!item.rightImei && '#ccc'}" class="chakan-btn" @click="toDevice(item,2)">右 笼</button>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div class="page">
                        <div @click="prev">上一页</div>
                        <div style="margin:0 2%;">第{{option.pageIndex}}页 共{{listTotal}}条</div>
                        <div @click="next">下一页</div>
                    </div>
                </div>
            </div>
        </main>
  </div>
</template>

<script>
import { companyPie,companyBar,companyLine,companyMap } from '../assets/js/echarts'
export default {
    data(){
        return{
            id: 0,
            info: {},
            chartInfo: {},
            mapInfo: {},
            historyList:[],
            option:{
                id: 0,
                pageSize: 11,
                pageIndex: 1
            },
            list: [],
            listLength: 0,
            listTotal: 0,
        }
    },
    methods:{
        //格式化表格
        listFomart(option){
            if(option.length < 11){
                for(let i=option.length; i<11; i++){
                    option.push({})
                }
            }
        },
        //公司基本信息
        getEnterpriseBasicInfo(option){
            this.$api.EnterpriseBasicInfo(option).then(res=>{
                this.info = res.data.data;
                if(this.info.nature == 1){
                    this.info.nature = '央企'
                }else if(this.info.nature == 2){
                    this.info.nature = '国企'
                }else if(this.info.nature == 3){
                    this.info.nature = '私企'
                }else{
                    this.info.nature = '其他'
                }
                if(this.info.trade == 1){
                    this.info.trade = '建筑企业'
                }else if(this.info.trade == 2){
                    this.info.trade = '租赁企业'
                }else{
                    this.info.trade = '其他'
                }
            })
        },
        //柱形图
        getEnterprisePurchaseInfo(option){
            this.$api.EnterprisePurchaseInfo(option).then(res=>{
                this.chartInfo = res.data.data;
                var temp = []
                this.chartInfo.yearPayDate.map((item,i)=>{
                    temp[i] = item.slice(5,7)
                })
                companyPie({doc:'.chart-pie',data:[{ name:'塔机',value:this.chartInfo.payTower },{ name:'升降机',value:this.chartInfo.payLifter }],text:this.chartInfo.payTotal})
                companyBar({doc:'.chart-line1',date:this.chartInfo.hisPayDate,towerData:this.chartInfo.hisPayTowerValue,lifterData:this.chartInfo.hisPayLifterValue});
                companyLine({doc:'.chart-line2',date:temp,towerData:this.chartInfo.yearTowerPayValue,lifterData:this.chartInfo.yearLifterPayValue});
            })
        },
        //地图数据
        getMachineDistributionInfo(option){
            this.$api.MachineDistributionInfo(option).then(res=>{
                this.mapInfo = res.data.data;
                this.historyList = res.data.data.saleList;
                if(this.historyList.length < 5){
                    for(let i=this.historyList.length; i<5; i++){
                        this.historyList.push({
                            salesPerson: '',
                            salesPersonTel: '',
                            count: '',
                        })
                    }
                }
                var mapData = []
                this.mapInfo.deviceList.map((item,i)=>{
                    mapData.push({
                        name: '设备',
                        value: [item.gpsX,item.gpsY],
                        type: item.type,
                        factorNo: item.factorNo,
                        machineNo:item.machineNo,
                        imei:item.imei,
                        rightImei:item.rightImei,
                        customerName:item.customerName
                    })
                })
                companyMap({doc:'.map',data:mapData})
            })
        },
        //表格数据
        getContractDataInfo(option){
            this.$api.ContractDataInfo(option).then(res=>{
                this.listTotal = res.data.data.total;
                this.list = res.data.data.data;
                this.listLength = this.list.length;
                this.listFomart(this.list);
            })
        },
        //跳转至设备页面
        toDevice(item,p){
            if(item.type==1){
                this.$router.push('/TowerBigScreen?imei='+item.imei)
            }else{
                if(p == 1){
                    this.$router.push('/LifterBigScreen?imei='+item.imei + '&cagecate=' + 1)
                }else{
                    this.$router.push('/LifterBigScreen?imei='+item.rightImei + '&cagecate=' + 2)
                }
            }
        },
        //上一页
        prev(){
            if (this.option.pageIndex <= 1) return;
            this.option.pageIndex --;
            this.getContractDataInfo(this.option);
        },
        //下一页
        next(){
            if(this.listLength < this.option.pageSize) return;
            this.option.pageIndex ++;
            this.getContractDataInfo(this.option);
        }
    },
    created(){
        this.id = this.$route.query.id;
        this.option.id = this.id;
    },
    mounted(){
        this.getContractDataInfo(this.option);
        this.getEnterpriseBasicInfo({id:this.id});
        this.getEnterprisePurchaseInfo({id:this.id});
        this.getMachineDistributionInfo({id:this.id});
    },
}
</script>

<style lang="scss" scoped>
.conrainer{
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    background: url('../assets/images/bigScreen_back.webp') no-repeat center center;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    color: #fff;
    padding: 0 1rem;
}
.head-title{
    font-size: 1.5625rem;
    font-weight: bold;
    letter-spacing: 5px;
}
main{
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
}
.top{
    height: 21%;
    display: flex;
    .chart-pie-box{
        width: 10%;
        display: flex;
        flex-direction: column;
        .chartitle{
            font-size: 1.0625rem;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: bold;
            height: 18%;
        }
        .chart-pie{
            flex: 1;
        }
    }
    .table-box{
        width: 32%;
        margin-left: 1%;
        table{
            border-collapse: collapse;
            table-layout: fixed;
            width: 100%;
            height: 100%;
            td{
                border: 1px solid #fff;
                text-align: center;
                padding: 0 10px;
                font-size: 14px;
            }
        }
    }
    .chart-line1{
        width: 27%;
        margin-left: 1.5%;
    }
    .chart-line2{
        width: 27%;
        margin-left: 1.5%;
    }
}
.bottom{
    flex: 1;
    display: flex;

}
.map{
    width: 40%;
}
@keyframes xuanzhuan {
    0%{ 
        transform: rotateZ(0deg);
    }
    100%{
        transform: rotateZ(360deg);
    }
}
.bottom-right{
    margin-left: 0.75rem;
    flex: 1;
    display: flex;
    flex-direction: column;
    .info{
        height: 24%;
        display: flex;
        align-items:center;
        .info-left{
            width: 48%;
            display: flex;
            .item{
                flex: 1;
            }
            .item-top{
                height: 75%;
                position: relative;
                display: flex;
                justify-content: center;
                align-items: center;
                img{
                    animation: xuanzhuan 15s linear infinite;
                }
            }
            .count{
                position: absolute;
                color: #bf0000;
                font-weight: bold;
                font-size: 1.8rem;
            }
            .item-title{
                height: 50%;
                font-size: 0.9375rem;
                display: flex;
                justify-content: center;
                align-items: center;
            }
        }
        .info-title{
            width: 8%;
            font-weight: bold;
            font-size: 17px;
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            justify-content: center;
            padding-right: 1.5rem;
        }
        .info-ul{
           flex: 1;
           height: 90%;
           ul{
               width: 100%;
               height: 100%;
               li{
                   display: flex;
                   align-items: center;
                   height: 20%;
                   font-size: 15px;
                   div{
                      flex: 1;
                      height: 100%;
                      width: 25%;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      white-space: nowrap;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                   }
               }
           }
        }
    }
    .tabletitle{
        height: 5%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .tablebox{
        flex: 1;
        table{
            width: 100%;
            height: 100%;
            border-collapse: collapse;
            table-layout: fixed;
            font-size: 15px;
            text-align: center;
            td{
                border: 1px solid #fff;
                padding: 0 0.4375rem;
                button{
                    background: #EDB941;
                    color: #fff;
                    width: 45%;
                    height: 58%;
                    line-height: 0;
                    font-size: 0.8125rem;
                    border-radius: 3px;
                    cursor: pointer;
                }
                button:active{
                    background: rgba($color: #EDB941, $alpha: 0.9);
                }
            }
        }
    }
    .page{
        display: flex;
        align-items: center;
        justify-content: center;
        height: 6%;
        font-weight:bold;
        font-size: 0.9375rem;
        & div{ cursor: pointer;}
        & div:active{ color: #EDB941;}
    }
}
</style>